<template>
    <div :class="[$options.name, 'dark']">
        <div class="content">
            <div class="description">
                <h3 class="heading -xl">
                    Get In Touch
                </h3>
            </div>
            <div class="email">
                <a
                    class="url"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="mailto:cat.dattoma@gmail.com"
                >
                    cat.dattoma@gmail.com
                </a>
            </div>
            <div class="socials-wrapper">
                <a
                    class="social linkedin"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Katy Dattoma Linkedin Profile"
                    href="https://linkedin.com/caterinadattoma"
                >
                    <font-awesome-icon class="icon" :icon="['fab', 'linkedin']" />
                </a>
                <a
                    class="social gituhub"
                    target="_blank"
                    rel="noopener noreferrer" 
                    aria-label="Katy Dattoma Github Profile"
                    href="https://github.com/katydatt"
                >
                    <font-awesome-icon class="icon" :icon="['fab', 'github']" />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import gsap from 'gsap'

export default {
    name: 'contact'
}
</script>
<style lang="scss" scoped>
.contact {
    width: 100%;
    color: $white;
    text-align: left;
    position: relative;
    .svg {
        transform: scaleX(-1);
    }
    .content {
        top: 50%;
        left: 50%;
        width: 90%;
        text-align: center;
        position: absolute;
        transform: translateY(-50%) translateX(-50%);
        @include g-state(tabletUp) {
            text-align: left;
        }
        .description {
            .heading {
                text-shadow: 6px 6px 0 var(--darker-color);
            }
        }
        .email {
            font-size: 3.5vw;
            margin: 0.5rem auto;
            .url {
                color: $white;
            }
        }
    }
    .socials-wrapper {
        width: 10rem;
        display: flex;
        margin: 0 auto;
        align-items: center;
        justify-content: center;
        @include g-state(tabletUp) {
            margin: 1rem 0;
            justify-content: flex-start;
        }
        .social {
            width: 2.5rem;
            color: $white;
            margin-right: 1rem;
            transition: all 0.3s ease;
            svg {
                width: 100%;
                height: auto;
            }
            &:hover {
                transform: scale(1.1);
            }
        }
    }
}
</style>